import { PrimaryButton } from "components/ButtonMenu/Button";
import OrderCard from "components/OrderCard";
import { getCartTotalPrice } from "helpers/cartHelpers";
import "@reach/dialog/styles.css";
import { getTranslation } from "dictionary";
import { Features } from ".prisma/client";
import { getFormatedPrice } from "helpers";
import { CurrencySymbol } from "context/MenuContext";
import { useEffect, useState } from "react";

interface Props {
  onRemove: (index: number) => void;
  currency_symbol: CurrencySymbol;
  language: "ES" | "EN";
  changeCartQuantity: (
    index: number,
    action: "INCREMENT" | "DECREMENT"
  ) => void;
  state: any;
  onConfirm: () => void;
  features: Features;
  savingOrder: boolean;
  skipStep2: boolean;
}

function setCookie(cname: String, cvalue: String) {
  const d = new Date();
  d.setTime(d.getTime() + (4*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname: String) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const OrderModalStep1: React.FC<Props> = ({
  onRemove,
  currency_symbol,
  language,
  skipStep2,
  changeCartQuantity,
  onConfirm,
  state,
  savingOrder,
  features,
}) => {
  const [hasTableCookie, setHasTableCookie] = useState(true);
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    const tabletitle = getCookie("tabletitle");
    if (!tabletitle) {
      setHasTableCookie(false);
    }
  }, []);

  return (
    <div className="bg-white h-full overflow-hidden">
      <ul className="h-[calc(100vh-320px)] overflow-scroll show-scrollbar mr-1 mt-1">
        {
          //@ts-ignore
          state.products.map((item, productIdx) => (
            <OrderCard
              key={item.itemId}
              item={item}
              //@ts-ignore

              onChangeCartQuantity={(action) =>
                changeCartQuantity(productIdx, action)
              }
              onRemove={() => onRemove(productIdx)}
            />
          ))
        }
      </ul>
      <div className="px-4 pt-4 pb-12 border-t border-gray-900 min-h-fit">
        {!hasTableCookie && features === "BAR_FULL" && (
          <div className="flex gap-2 w-full items-center mb-6">
            <label className="whitespace-nowrap" htmlFor="add_cookie">Numero de mesa</label>
            <input id="add_cookie" className="px-2 w-full border border-input-border text-input rounded focus:border-black focus:outline-black" onChange={(e) => setInputValue(e.target.value)} value={inputValue}/>
          </div>
        )}
        <div className="text-lg flex justify-between items-center mb-6">
          <span className="font-medium">Total</span>
          <span className="text-lg font-medium ml-4">
            {getFormatedPrice(
              getCartTotalPrice(state.products),
              currency_symbol
            )}
          </span>
        </div>

        <PrimaryButton
          ariaLabel="Checkout"
          loading={savingOrder}
          disabled={!inputValue && !hasTableCookie && features === "BAR_FULL"}
          onClick={()=>{
            if(!hasTableCookie && features === "BAR_FULL"){
              setCookie("tabletitle", inputValue)
            }
            onConfirm()}}
        >
          {skipStep2
            ? getTranslation("menu_order", "CHECKOUT", language)
            : getTranslation("menu_order", "CONTINUE", language)}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default OrderModalStep1;
